<div class="comparativeContainer gap-4 flex flex-col">
  <app-grid
    class="relative z-0"
    [data]="quotationComparatives"
    [columns]="columns"
    [displayColumns]="displayColumns"
    [pageSize]="4"
    [pageSizeOptions]="[3, 4, 10]"
    [hasButton]="true"
    (mainButtonEvent)="selectQuotation($event)"
  ></app-grid>

  <div class="w-full flex justify-center gap-4 h-14">
    @if (
      hasQuotation &&
      updateEnabled &&
      isUpdate === 1 &&
      quotationComparatives.length > 0 &&
      isSelectedAny()
    ) {
      <button
        matButton="filled"
        class="w-45 !=h-13! rounded-xl text-white! text-general bg-primary!"
        (click)="updateTicket()"
      >
        {{ 'quotation.fieldNames.update' | translate }}
      </button>
    }

    @if (enableSend && (Page == 4 || Page == 15)) {
      <button
        matButton="filled"
        class="w-45 h-13! rounded-xl text-white! text-general bg-primary!"
        (click)="sendTicket()"
      >
        @if (isOnLeaseLine === 0) {
          {{ 'quotation.fieldNames.sendToIntegration' | translate }}
        } @else {
          {{ 'quotation.fieldNames.sendToConfirmation' | translate }}
        }
      </button>
    }
  </div>
</div>
